/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { toggle_off, toggle_on } from "../../assets/img";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import CurrentStepCard from "./CurrentStepCard";
import DragAndDrop from "../../components/Property/DragAndDrop";
import { checkPermission } from "../redux/api/PermissionManager";

const PropertyDocEdit = () => {
  const isUploading = useRef(false);
  const [addPopup, setAddPopup] = useState(false);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState([]);
  const [draggableImages, setDraggableImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [receptionist, setReceptionist] = useState("");
  const [text, setText] = useState([]);
  const [popUpData, setPopupData] = useState({
    name: "",
    image: "",
  });
  const [receptionistOptions, setReceptionistOptions] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();
  const type =
    !checkPermission("CAN-ADD-DOCUMENT_VERIFICATION") &&
    !checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION")
      ? "view"
      : location?.state?.type;
  const id = location?.state?.id;
  const owner_id = location?.state?.owner_id;
  console.log("type", type);
  const [selectedReceptionists, setSelectedReceptionists] = useState([]);

  useEffect(() => {
    getReceptionist();
    viewProperty();
  }, []);

  const viewProperty = async () => {
    const res = await get(URLS.PROPERTY_MASTER + id);
    console.log("view property", res);
    if (res?.status === "success") {
      let { documents, images, details } = res?.data;
      let images_arr = [];
      images?.forEach((item) => {
        if (item?.type === 2) {
          images_arr.push({ ...item, image: item?.image_name });
        }
      });
      console.log("images array", documents);
      let document_arr = documents?.map((item) => ({
        id: item?.id,
        name: item?.doc_name,
        image: item?.doc_file_name,
      }));
      let reception = res?.data?.receptionists?.map((item) => ({
        value: item?.id,
        label: item?.name,
        code: item?.code,
      }));
      setDraggableImages(images_arr);
      setSelectedImage(document_arr);
      setText(details?.additional_texts || []);
      setReceptionist(reception.length !== 0);
      setSelectedReceptionists(reception);
    }
  };
  const handleChange = (selected) => {
    console.log(
      "console.log selected",
      selected,
      selectedReceptionists,
      selectedImage,
    );
    setSelectedReceptionists(selected || []);
  };

  // Custom Option with Radio Button
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div
          key={props.value}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{props.label}</span>
          <div className="">
            <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
              ID: {props.data?.code}
            </span>
            <button
              style={{
                marginLeft: "auto",
                height: "16px",
                width: "16px",
                borderRadius: "50%",
                border: "2px solid #9A36E6",
                display: "inline-block",
                position: "relative",
              }}
            >
              {props.isSelected && (
                <span
                  style={{
                    height: "8px",
                    width: "8px",
                    backgroundColor: "#9A36E6",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              )}
            </button>
          </div>
        </div>
      </components.Option>
    );
  };
  const handleRemove = (value) => {
    setSelectedReceptionists((prev) =>
      prev.filter((item) => item.value !== value),
    );
  };

  const CustomMultiValue = () => null;

  const handleImageClick = () => {
    inputRef.current.click();
  };

  const editDocHandler = (index, file) => {
    console.log("edit doc handler", file);
    // setType("edit");
    setAddPopup(true);
    setPopupData({
      ind: index,
      id: file?.id,
      name: file?.name,
      image: file?.image,
    });
  };

  const handleAddText = () => {
    setText((prev) => [...prev, { title: "", description: "" }]); // append new policy to array
  };
  const handleChangeText = (index, value) => {
    setText((prev) => prev.map((item, i) => (i === index ? value : item)));
  };
  const handleTextDelete = (index) => {
    setText((prev) => prev.filter((_, i) => i !== index));
  };

  const getReceptionist = async () => {
    const res = await get(URLS.RECEPTIONIST_OVERALL + owner_id + "/");
    console.log("receptionist res", res);
    if (res?.status === "success") {
      let tempList = res?.data?.map((item) => ({
        value: item?.id,
        label: item?.name,
        code: item?.code,
      }));
      setReceptionistOptions(tempList);
    }
  };

  const handleSubmit = async () => {
    if (!popUpData?.name) {
      toast.error("Enter Document Name");
      return;
    }
    if (!popUpData?.image) {
      toast.error("Enter Document");
      return;
    } else {
      const payload = new FormData();
      if (popUpData?.id) {
        payload.append("delete_doc_id", popUpData?.id);
      }
      payload.append("doc_name", popUpData?.name);
      payload.append("doc_file", popUpData?.image);
      console.log("fghjksadjkas", payload);

      const res = await post(
        URLS.PROPERTY_MASTER + id + "/documents/upload/",
        payload,
      );
      console.log("document upload", res, popUpData);
      if (res?.status === "success") {
        let temp = [...selectedImage];
        if (popUpData?.ind) {
          temp[popUpData?.ind] = popUpData;
        } else {
          temp = [...temp, popUpData];
        }
        setSelectedImage(temp);
        onReset();
        setAddPopup(false);
      }
    }
  };

  const onReset = () => {
    setPopupData({
      name: "",
      image: "",
    });
  };

  const addDocHandler = () => {
    if (selectedImage.length >= 10) {
      toast.error("Maximum 10 Documents Allowed");
      return;
    }
    setAddPopup(true); // Open popup
  };

  // const handleFimalSubmit = async () => {
  //   if (isUploading.current) {
  //     return;
  //   }
  //   isUploading.current = true;
  //   if (
  //     text.length === 0 &&
  //     draggableImages.length === 0 &&
  //     selectedImage.length === 0
  //   ) {
  //     toast.error("Please upload any one of the Feild...");
  //     return;
  //   }
  //   const payload = new FormData();
  //   payload.append("additional_texts", JSON.stringify(text));
  //   if (receptionist) {
  //     payload.append(
  //       "receptionist_ids",
  //       JSON.stringify(selectedReceptionists?.map((item) => item.value)),
  //     );
  //   }
  //   let positions_list = [];
  //   draggableImages?.forEach((img, ind) => {
  //     payload.append("property_images", img?.image);
  //     positions_list.push(ind + 1);
  //   });

  //   payload.append("deleted_image_ids", deletedImages);
  //   payload.append("property_images_position", JSON.stringify(positions_list));
  //   console.log("payload", payload);
  //   const res = await post(
  //     URLS.PROPERTY_MASTER + id + "/documents/upload/",
  //     payload,
  //   );
  //   console.log("docement upload", res);
  //   if (res?.status === "success") {
  //     isUploading.current = false;
  //     toast.success(res?.message);
  //     navigate("/propertie-mmc-edit", {
  //       state: {
  //         type: "edit",
  //         current_position: "mmc",
  //         id: id,
  //         owner_id: owner_id,
  //       },
  //       replace: true,
  //     });
  //   }
  // };


const handleFimalSubmit = async () => {
    // 1. Check if already uploading
    if (isUploading.current) {
      return;
    }

    // 2. Run validations FIRST
    if (
      text.length === 0 &&
      draggableImages.length === 0 &&
      selectedImage.length === 0
    ) {
      toast.error("Please upload any one of the Feild...");
      return; // Exits safely without locking the submit button
    }

    // 3. Set uploading state only after validations pass
    isUploading.current = true;

    try {
      const payload = new FormData();
      payload.append("additional_texts", JSON.stringify(text));
      
      if (receptionist) {
        payload.append(
          "receptionist_ids",
          JSON.stringify(selectedReceptionists?.map((item) => item.value)),
        );
      }
      
      let positions_list = [];
      draggableImages?.forEach((img, ind) => {
        payload.append("property_images", img?.image);
        positions_list.push(ind + 1);
      });

      payload.append("deleted_image_ids", deletedImages);
      payload.append("property_images_position", JSON.stringify(positions_list));
      
      console.log("payload", payload);
      
      const res = await post(
        URLS.PROPERTY_MASTER + id + "/documents/upload/",
        payload,
      );
      
      console.log("docement upload", res);
      
      if (res?.status === "success") {
        toast.success(res?.message);
        navigate("/propertie-mmc-edit", {
          state: {
            type: "edit",
            current_position: "mmc",
            id: id,
            owner_id: owner_id,
          },
          replace: true,
        });
      }
    } catch (error) {
      console.error("Upload failed", error);
      toast.error("An error occurred during submission.");
    } finally {
      // 4. Always reset the uploading state, success or fail
      isUploading.current = false;
    }
  };


  return (
    <div>
      <Topbar header={"Properties"} subHead={"Verification"} />
      <div>
        {/* {type == "edit" && ( */}
        <CurrentStepCard />
        {/* )} */}

        <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mt-4 red">
          Maximum 10 Documents Allowed
        </p>

        <p
          onClick={() => {
            addDocHandler();
          }}
          className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 green mb-4 pointer"
        >
          +Add Document
        </p>
        <div style={{ borderBottom: "2px solid #D9D9D9" }}>
          {selectedImage?.length !== 0 && (
            <div className="d-flex flex-wrap gap-5 pb-5">
              {selectedImage?.map((file, index) => (
                <div key={index} className="col-md-5">
                  <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    {file?.name}
                  </p>
                  <p
                    onClick={() => editDocHandler(index, file)}
                    className="doc-input pointer"
                  >
                    {typeof file?.image === "string"
                      ? file?.name + ".pdf"
                      : file?.image?.name}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>

        <div
          style={{
            borderBottom: "2px solid #D9D9D9",
            paddingBottom: "20px",
            marginTop: "20px",
          }}
        >
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  my-4 pointer d-flex ">
            <span>Upload Image</span>(Optional)
            <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red center mt-2 ms-3">
              Max Upload Size : 5MB and Banner Size 1200px 700px, Max 5 image*
            </p>
          </p>
          <DragAndDrop
            edit={type !== "view"}
            draggableImages={draggableImages}
            setDraggableImages={setDraggableImages}
            setDeletedImages={setDeletedImages}
          />
        </div>
        <p
          onClick={() => {
            handleAddText();
          }}
          className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  my-4 pointer"
        >
          <span className="green">+Add Text </span>(Optional)
        </p>
        <div className="">
          {text.map((item, ind) => {
            return (
              <div className="w-100 mt-5">
                <div className="d-flex ac-jb">
                  <input
                    className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 gray input-border w-30 "
                    placeholder="Text"
                    value={item?.title}
                    onChange={(e) => {
                      handleChangeText(ind, { ...item, title: e.target.value });
                    }}
                  />
                  <CloseSharpIcon
                    onClick={() => handleTextDelete(ind)}
                    className="pointer gray"
                  />
                </div>
                <div className="d-flex ae-jb input-border p-1">
                  <textarea
                    style={{ maxHeight: "100px" }}
                    value={item?.description}
                    onChange={(e) => {
                      handleChangeText(ind, {
                        ...item,
                        description: e.target.value,
                      });
                    }}
                    placeholder="Write Here...."
                    className="border-0 mb-3 w-100"
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="d-flex ac-js gap-3 mt-5">
          <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
            Receptionist
          </p>
          <button className="cust-btn">
            <img
              onClick={() => {
                if (receptionistOptions.length === 0) {
                  toast.error("No Receptionist Available");
                  return;
                }
                setReceptionist(!receptionist);
              }}
              src={receptionist ? toggle_on : toggle_off}
              className="roles-icon pointer"
              alt=""
            />
          </button>
        </div>
        {receptionist && (
          <div className={" mb-5  col-md-4 "}>
            <p className=" f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 sec mt-4">
              Add Receptionist
            </p>

            <div>
              <Select
                options={receptionistOptions}
                value={selectedReceptionists}
                onChange={handleChange}
                placeholder="Select Receptionist"
                isMulti
                isSearchable
                isClearable={false}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option: CustomOption,
                  MultiValue: CustomMultiValue, // hides inside select
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#ccc",
                    minHeight: "40px",
                  }),
                }}
              />

              {/* Selected items OUTSIDE the select box */}
              {selectedReceptionists.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  {selectedReceptionists.map((person) => (
                    <div
                      key={person.value}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "6px",
                        padding: "6px 10px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                      }}
                    >
                      <span>{person.label}</span>
                      <div className="">
                        <span className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 me-3 sec">
                          ID: {person.code}
                        </span>
                        <button
                          onClick={() => handleRemove(person.value)}
                          style={{
                            marginLeft: "auto",
                            height: "16px",
                            width: "16px",
                            borderRadius: "50%",
                            border: "2px solid #9A36E6",
                            display: "inline-block",
                            position: "relative",
                          }}
                        >
                          <span
                            style={{
                              height: "8px",
                              width: "8px",
                              backgroundColor: "#9A36E6",
                              borderRadius: "50%",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {addPopup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <div className="d-flex ac-je">
                <CloseSharpIcon
                  onClick={() => {
                    setAddPopup(false);
                    onReset();
                  }}
                  className="pointer"
                />
              </div>
              <div className="">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 text-start">
                  Name
                </p>
                <input
                  className="doc-input"
                  name="email"
                  value={popUpData?.name}
                  onChange={(e) =>
                    setPopupData((pre) => ({ ...pre, name: e.target.value }))
                  }
                  type="text"
                  placeholder="Document Name"
                />
              </div>
              <div className="d-flex ae-jb px-2 mt-4">
                <div className="w-60">
                  <div className=" w-100 d-flex ac-jb">
                    <div className="position-relative w-100">
                      <div className=" w-100">
                        <div>
                          {console.log("sssss", selectedImage)}

                          <div className="d-flex ae-js gap-1">
                            <p
                              className="bg-gray1 white rounded d-flex ac-jc"
                              style={{ height: "50px", width: "60%" }}
                            >
                              {typeof popUpData?.image === "string"
                                ? popUpData?.name + ".pdf"
                                : popUpData?.image?.name
                                  ? popUpData?.image?.name
                                  : "No file chosen"}
                            </p>
                            {popUpData?.image && (
                              <button
                                className="view-btn d-flex gap-2 mt-1 "
                                onClick={() =>
                                  window.open(
                                    typeof popUpData?.image === "string"
                                      ? popUpData?.image
                                      : URL.createObjectURL(popUpData?.image),
                                  )
                                }
                              >
                                View
                              </button>
                            )}
                          </div>
                          <input
                            style={{
                              position: "absolute",
                              width: "100px",
                              height: "100px",
                              left: "0px",
                              top: "0px",
                            }}
                            type="file"
                            hidden
                            name="myImage"
                            accept="application/pdf"
                            ref={inputRef}
                            onChange={(e) =>
                              setPopupData((pre) => ({
                                ...pre,
                                image: e.target.files[0],
                              }))
                            }
                          />
                          <button
                            className="submit-btn d-flex gap-2 mt-1 "
                            onClick={handleImageClick}
                          >
                            <CloudUploadRoundedIcon /> Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION") && (
                  <button
                    onClick={() => {
                      handleSubmit();
                      // logout();
                    }}
                    className="submit-btn f2 w-40"
                  >
                    {/* {loading ? "Loading..." : "Confirm"}  {type == "edit" ? "Submit" : "Add"} */}
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION") && (
        <div className="d-flex ac-je mt-5">
          <button
            onClick={handleFimalSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
};

export default PropertyDocEdit;
